<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4>Fabric Category Matchings</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-4">
            <h5>AREA</h5>
            <v-select
              placeholder="SELECT AREA"
              v-model="shirtOrderStatusId"
              :options="areas"
              @input="changeArea"
              :reduce="(areas) => areas.id"
            />
          </div>
          <div class="col-md-4" v-if="shirtOrderStatusId != null">
            <h5>STATION</h5>
            <v-select
              placeholder="SELECT STATION"
              v-model="stationId"
              :options="stations"
              label="name"
              @input="changeStation"
              :reduce="(stations) => stations.id"
            />
          </div>
        </div>
        <br />

        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="fabric-number">Fabric Number</th>
              <th>Category</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fabric, index) in fabrics" :key="fabric.id">
              <td>
                {{ fabric.full_name }}
              </td>
              <td class="text-center">
                <select
                  class="form-control fabric-category"
                  v-model="fabric.category"
                  @change="setCategory(index)"
                >
                  <option value="1" selected>Category 1</option>
                  <option value="2">Category 2</option>
                  <option value="3">Category 3</option>
                  <option value="4">Category 4</option>
                  <option value="5">Category 5</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import AreaStatusMatching from "./tools/AreaStatusMatching.json";
import vSelect from "vue-select";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      fabrics: [],
      areas: [],
      shirtOrderStatusId: null,
      stationId: null,
      stations: [],
    };
  },
  mounted() {
    this.getAreas();
  },
  methods: {
    getAreas() {
      let data = AreaStatusMatching.en;
      data.forEach((val) => {
        this.areas.push(val);
      });
    },
    async getStations() {
      let res = await axios.get(
        "performance_tracking/station/listings/" + this.shirtOrderStatusId
      );
      this.stations = res.data;
    },
    async getFabrics() {
      let res = await axios.get(
        "performance_tracking/fabric_category_matchings/" + this.stationId
      );
      this.fabrics = res.data;
    },
    changeArea() {
      this.stationId = null;
      this.fabrics = [];
      this.getStations();
    },
    changeStation() {
      if (this.stationId != null) {
        this.getFabrics();
      } else {
        this.fabrics = [];
      }
    },
    setCategory(index) {
      let fabric = this.fabrics[index];
      let data = {
        station_id: this.stationId,
        fabric_id: fabric.id,
        category: fabric.category,
      };
      axios.post("performance_tracking/fabric_category_matchings", data);
    },
  },
};
</script>

<style scoped>
.fabric-category {
  width: 200px;
}
.fabric-number {
  width: 300px;
}
</style>
